import * as Sentry from "@sentry/react";

/**
 * Init de Sentry para el FE.
 * Se importa de primero en main.tsx — cualquier error de React o unhandled
 * promise queda capturado.
 *
 * Si VITE_SENTRY_DSN no está seteado, Sentry no arranca (no crash).
 */
const dsn = import.meta.env.VITE_SENTRY_DSN;

if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.2,
  });
}

export { Sentry };
